<template>
    <div>
      <s-button label="Aide" icon="question" theme="is-info" @onclick="openModal"/>
      <s-modal
            title="Sommaire des aides"
            :open="modal_help"
            :close="true"
            @close="modal_help=false"
      >
      <div v-for="(chapitre, indexChapitre) in chapitres.chapitres" class="chapitre" v-if="chapitres">
           <s-button @onclick="displayVideos(chapitre)" 
            :icon=" chapitreCurrent.id == chapitre.id ? 'arrow-down' : 'arrow-up'" :label="chapitre.label" 
            :theme=" chapitreCurrent.id == chapitre.id ? 'is-success' : ''"/>
            
           <div v-show="chapitreCurrent.id == chapitre.id" class="chapitreVideos">
                <div v-for="(video, indexVideo) in chapitre.videos" class="video">
                    <s-button @onclick="idYouTubeRead = video.idYouTube" icon="film" theme="is-info" 
                        :label="video.label"/>&nbsp;
                </div>
                <div v-if="pasDeVideos(chapitre)">
                    Pas de videos
                </div>

           </div>
        </div>
      </s-modal>
        <s-modal
            title="Lire la vidéo"
            :open="idYouTubeRead!=null"
            @close="idYouTubeRead=null"
            :close="true">
            <youtube width="100%" 
                            :video-id="idYouTubeRead" 
                            :player-vars="playerVars"  
                            :ref="idYouTubeRead"
                            @playing="playing"
                            @paused="paused"
                            @ended="ended"></youtube> 
        </s-modal>
    </div>
</template>
<style scoped>
    .chapitre {
        margin: 1px;
        margin-bottom: 10px;
        color: black;
        font-size: 20px;
    }
    .chapitreVideos {
       
        margin: 0px;
        padding: 0px;
    }
    .video {
        margin-left: 0px;
        margin-top: 5px;
        font-size: 20px;
    }
</style>
<script>
import firebase_api from "@/firebase/firebase_api"
 
export default ({
    props: ["chapitre", "youtube"],
    
    data() {
        return {
            idYouTubeRead: null,
            
            modal_help: false,
           
            
            chapitreCurrent: {
                id: null
            },
           
             playerVars: {
                autoplay: 0,
                host: 'https://www.youtube.com',
                autohide: 0,
                fs: 1,
                modestbranding: 0,
                color: 'white',
                iv_load_policy: 3,
                cc_load_policy: 1,
                rel: 0,
                showinfo:1,
                controls:1
            },
        }
    },
    mounted() {
       
    },
    computed: {
        chapitres: {
            get() {
                return this.$store.getters.getHelpChapitres;
            }
        },
    },
    methods: {
        pasDeVideos(chapitre) {
            if (typeof(chapitre.videos)=="undefined")
               return true;
            else 
                return chapitre.videos.length == 0;
        },
        playing() {
            
        },
        paused() {
           
        },
        ended() {
            
        },
        openModal() {
            
            if (typeof(this.chapitre)!="undefined")
                this.chapitreCurrent.id = this.chapitre;
            if (typeof(this.youtube)!="undefined")
                this.idYouTubeRead = this.youtube;
            this.modal_help = true;
            var chapitre = this.chapitres.chapitres.find(chapitreItem=>chapitreItem.id === this.chapitreCurrent.id);
            chapitre.videos.forEach(video => {
                if (video.default)
                    this.idYouTubeRead = video.idYouTube;
            });
        },
        displayVideos(chapitre) {
            if (chapitre.id == this.chapitreCurrent.id)
                    this.chapitreCurrent = {
                        id: null
                    }
            else 
                this.chapitreCurrent = JSON.parse(JSON.stringify(chapitre));
        },
       
        
      
    }

})
</script>
